import { HealerInfo } from '../../core/models/healer-info';
import { extractMessageFromError } from '../../infra/adapters/luminara/common/ErrorUtil';

export interface HealerInfoState {
  healerDetails?: HealerInfo;
  loadingDataError?: string;
}

export const initialHealerInfoState = () =>
  ({
    healerDetails: undefined,
    loadingDataError: undefined,
  } as HealerInfoState);

export interface HealerInfoAction {
  type: 'LOAD_HEALER_INFO_SUCCESS' | 'LOAD_HEALER_INFO_FAILURE';
  payload?: any;
}

const healerInfoReducer = (state: HealerInfoState = initialHealerInfoState(), action: HealerInfoAction): HealerInfoState => {
  switch (action.type) {
    case 'LOAD_HEALER_INFO_SUCCESS':
      return {
        ...state,
        healerDetails: action.payload,
      };
    case 'LOAD_HEALER_INFO_FAILURE':
      return { ...state, loadingDataError: extractMessageFromError(action.payload) };
    default:
      return state;
  }
};

export default healerInfoReducer;
